import React, { Component } from 'react';
import { connect } from "react-redux";

class EqualizerPointInfo extends Component {

    render() {
        let pt = this.props.equalizerPoint;
        let className = pt.enabled ? "equalizer-point-info" :
            "equalizer-point-info disabled";
        if (this.props.selected) {
            className += ' selected';
        }
        return (
            <div
              onClick={this.props.onClick}
              className={className}>
              <div className="equalizer-point-number">{pt.number}</div>
            </div>
        );
    }
}

const mapStateToProps = (state, props) => {
};

export default EqualizerPointInfo;
